export interface Quest {
  id: string;
  title: string;
  description: string;
  giver: string;
  location: string;
  objectives: string[];
  rewards: {
    experience: number;
    gold: number;
    romanceBonus?: number;
  };
  completed: boolean;
  difficulty: 'easy' | 'medium' | 'hard';
}

export const QUESTS: Quest[] = [
  {
    id: 'quest-ei-mystery',
    title: "Ei's Mystery",
    description: 'Ei Bhaal hints at secrets hidden in the deeper corners of Dark Hells. Perhaps uncovering them will bring you closer.',
    giver: 'Ei Bhaal',
    location: 'The Lazerate',
    objectives: [
      'Speak with Ei about the past',
      'Explore The Mushroom Caves',
      'Discover the truth about your coma',
    ],
    rewards: {
      experience: 500,
      gold: 250,
      romanceBonus: 20,
    },
    completed: false,
    difficulty: 'medium',
  },
  {
    id: 'quest-yichen-research',
    title: "Yìchén's Research",
    description: 'The magician is studying ancient spells that could change everything. Help gather materials for their experiments.',
    giver: 'Yìchén',
    location: 'The Red Market',
    objectives: [
      'Gather Crystal Shards',
      'Find Rare Herbs',
      'Retrieve the Arcane Focus',
    ],
    rewards: {
      experience: 450,
      gold: 300,
      romanceBonus: 25,
    },
    completed: false,
    difficulty: 'medium',
  },
  {
    id: 'quest-countess-favor',
    title: 'The Countess Needs You',
    description: 'Countess Nadia has a task for someone with your skills. Gain favor with Vestuvia.',
    giver: 'Nadia',
    location: 'Vestuvia',
    objectives: [
      'Investigate the disturbance in The Badlands',
      'Defeat the beast terrorizing travelers',
      'Return to the Countess with proof',
    ],
    rewards: {
      experience: 600,
      gold: 400,
    },
    completed: false,
    difficulty: 'hard',
  },
  {
    id: 'quest-oasis-peace',
    title: 'Oasis Restoration',
    description: 'The Oasis is being poisoned. Find the source and restore balance to this sacred place.',
    giver: 'Desert Elder',
    location: 'The Oasis',
    objectives: [
      'Find the source of contamination',
      'Cleanse the poisoned waters',
      'Restore the sacred balance',
    ],
    rewards: {
      experience: 550,
      gold: 200,
    },
    completed: false,
    difficulty: 'hard',
  },
  {
    id: 'quest-mage-knowledge',
    title: 'Knowledge of the Ancients',
    description: 'The Mage College seeks to recover lost tomes from the vault of The Lazerate.',
    giver: 'Mage Master',
    location: 'The Lazerate',
    objectives: [
      'Unlock the ancient vault',
      'Retrieve three forbidden tomes',
      'Return without triggering the wards',
    ],
    rewards: {
      experience: 700,
      gold: 500,
    },
    completed: false,
    difficulty: 'hard',
  },
];
